import React from 'react';
import './CustomerSearchBar.css';

const CustomerSearchBar = ({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  dateFilter,
  onDateFilterChange
}) => {
  return (
    <div className="customer-search-bar">
      <div className="search-input-wrapper">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search by name, phone, email..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="filter-controls">
        <select
          className="filter-select"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="totalSpent">Sort by: Total Spent</option>
          <option value="totalOrders">Sort by: Total Orders</option>
          <option value="lastOrder">Sort by: Last Order</option>
          <option value="name">Sort by: Name</option>
        </select>

        <select
          className="filter-select"
          value={dateFilter}
          onChange={(e) => onDateFilterChange(e.target.value)}
        >
          <option value="allTime">Joined: All Time</option>
          <option value="thisMonth">Joined: This Month</option>
          <option value="last3Months">Joined: Last 3 Months</option>
          <option value="last6Months">Joined: Last 6 Months</option>
          <option value="thisYear">Joined: This Year</option>
        </select>
      </div>
    </div>
  );
};

export default CustomerSearchBar;

